
import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Play, Home, Shield, Zap, Wifi, Star, ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const trustedBrands = [
  { name: 'HomeSeer', logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=50&fit=crop' },
  { name: 'Google Home', logo: 'https://images.unsplash.com/photo-1573804633927-bfcbcd909acd?w=100&h=50&fit=crop' },
  { name: 'Alexa', logo: 'https://images.unsplash.com/photo-1589492477829-5e65395b66cc?w=100&h=50&fit=crop' },
  { name: 'Sonos', logo: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=100&h=50&fit=crop' },
  { name: 'Insteon', logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=50&fit=crop' },
  { name: 'Fibaro', logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=50&fit=crop' },
  { name: 'Lutron', logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=50&fit=crop' }];


  const features = [
  { icon: <Home className="w-6 h-6" data-id="btuuozhoo" data-path="src/components/HeroSection.tsx" />, text: 'Control Total' },
  { icon: <Shield className="w-6 h-6" data-id="7bbwuy8v0" data-path="src/components/HeroSection.tsx" />, text: 'Seguridad 24/7' },
  { icon: <Zap className="w-6 h-6" data-id="18k40iv5t" data-path="src/components/HeroSection.tsx" />, text: 'Ahorro Energético' },
  { icon: <Wifi className="w-6 h-6" data-id="hb811eexr" data-path="src/components/HeroSection.tsx" />, text: 'Conectividad Total' }];


  return (
    <section id="inicio" className="relative bg-gradient-to-br from-gray-50 to-blue-50 overflow-hidden" data-id="wyr2tuzxa" data-path="src/components/HeroSection.tsx">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="8gh16xf0e" data-path="src/components/HeroSection.tsx">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=%2220%22 height=%2220%22 viewBox=%220 0 20 20%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22%23000%22 fill-opacity=%220.1%22%3E%3Ccircle cx=%223%22 cy=%223%22 r=%223%22/%3E%3C/g%3E%3C/svg%3E')] bg-repeat" data-id="6ugqg0ruc" data-path="src/components/HeroSection.tsx" />
      </div>

      <div className="container mx-auto px-4 py-16 lg:py-24" data-id="lkb19l70h" data-path="src/components/HeroSection.tsx">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="eu1nkwftk" data-path="src/components/HeroSection.tsx">
          {/* Left Content */}
          <div className="space-y-8" data-id="maxjcrct7" data-path="src/components/HeroSection.tsx">
            <div className="space-y-4" data-id="bml3sdybw" data-path="src/components/HeroSection.tsx">
              <Badge className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 text-sm font-medium" data-id="m3gr0mqr8" data-path="src/components/HeroSection.tsx">
                🚀 Líderes en Automatización de Casas
              </Badge>
              
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight" data-id="irsmhjs64" data-path="src/components/HeroSection.tsx">
                <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" data-id="e42er3l6c" data-path="src/components/HeroSection.tsx">
                  Automatiza.me:
                </span>
                <br data-id="aykp3gxer" data-path="src/components/HeroSection.tsx" />
                Tu Hogar Cobra Vida
              </h1>
              
              <p className="text-xl text-gray-600 leading-relaxed" data-id="z239sparj" data-path="src/components/HeroSection.tsx">
                Transformamos tu espacio en un hogar inteligente con soluciones personalizadas, convenientes y seguras. 
                <span className="font-semibold text-blue-600" data-id="roy6yh1km" data-path="src/components/HeroSection.tsx"> Experimenta la magia de la automatización</span> - 
                control inteligente al alcance de tu mano.
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-2 gap-4" data-id="84p51rfp4" data-path="src/components/HeroSection.tsx">
              {features.map((feature, index) =>
              <div key={index} className="flex items-center space-x-3 p-4 bg-white/80 rounded-lg backdrop-blur-sm border border-gray-200 hover:shadow-lg transition-all duration-300" data-id="di86963oz" data-path="src/components/HeroSection.tsx">
                  <div className="text-blue-600 bg-blue-50 p-2 rounded-lg" data-id="jfacj7z23" data-path="src/components/HeroSection.tsx">
                    {feature.icon}
                  </div>
                  <span className="font-medium text-gray-800" data-id="2fd0p19op" data-path="src/components/HeroSection.tsx">{feature.text}</span>
                </div>
              )}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4" data-id="t2vubsr7e" data-path="src/components/HeroSection.tsx">
              <Button
                size="lg"
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-4 rounded-lg font-medium text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl" data-id="hs3d63itg" data-path="src/components/HeroSection.tsx">

                Agenda tu Consulta Gratuita
                <ArrowRight className="w-5 h-5 ml-2" data-id="jyzw0zbat" data-path="src/components/HeroSection.tsx" />
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 rounded-lg font-medium text-lg transition-all duration-300 flex items-center space-x-2"
                onClick={() => window.open('https://www.youtube.com/watch?v=3cM5qblhdxU&t=4s', '_blank')} data-id="43cws7s90" data-path="src/components/HeroSection.tsx">

                <Play className="w-5 h-5" data-id="24puv2umm" data-path="src/components/HeroSection.tsx" />
                <span data-id="abpe04hc1" data-path="src/components/HeroSection.tsx">Ver Demo</span>
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-2 text-sm text-gray-600" data-id="qxpu9bvyz" data-path="src/components/HeroSection.tsx">
              <div className="flex items-center" data-id="uccpqzgym" data-path="src/components/HeroSection.tsx">
                {[...Array(5)].map((_, i) =>
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="vow2pt9q4" data-path="src/components/HeroSection.tsx" />
                )}
              </div>
              <span className="font-medium" data-id="08bpzemiy" data-path="src/components/HeroSection.tsx">4.9/5</span>
              <span data-id="xwkzrwg6d" data-path="src/components/HeroSection.tsx">• 500+ hogares transformados</span>
              <span data-id="77v3lq4kc" data-path="src/components/HeroSection.tsx">• 25 años de experiencia</span>
            </div>
          </div>

          {/* Right Content - Hero Image/Video */}
          <div className="relative" data-id="vbhqiduyo" data-path="src/components/HeroSection.tsx">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="xgvytlbo5" data-path="src/components/HeroSection.tsx">
              <iframe
                src="https://www.youtube.com/embed/3cM5qblhdxU?start=4"
                title="Automatiza.me - Demo del Hogar Inteligente"
                className="w-full h-96 lg:h-[500px]"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen data-id="nuyghca0g" data-path="src/components/HeroSection.tsx" />

              
              {/* Floating Cards */}
              <div className="absolute -top-4 -right-4 bg-white rounded-lg p-4 shadow-lg" data-id="yzu0on3ip" data-path="src/components/HeroSection.tsx">
                <div className="flex items-center space-x-2" data-id="gwcigyqj3" data-path="src/components/HeroSection.tsx">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" data-id="5f8ritnzh" data-path="src/components/HeroSection.tsx" />
                  <span className="text-sm font-medium" data-id="nads3109e" data-path="src/components/HeroSection.tsx">Casa Activa</span>
                </div>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-white rounded-lg p-4 shadow-lg" data-id="33eokbixy" data-path="src/components/HeroSection.tsx">
                <div className="text-center" data-id="za95togzj" data-path="src/components/HeroSection.tsx">
                  <div className="text-2xl font-bold text-blue-600" data-id="2w5g19bvx" data-path="src/components/HeroSection.tsx">-40%</div>
                  <div className="text-sm text-gray-600" data-id="7h1ln35xf" data-path="src/components/HeroSection.tsx">Ahorro Energético</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trusted Brands Section */}
      <div className="bg-white/80 backdrop-blur-sm border-t border-gray-200" data-id="qxh2ty430" data-path="src/components/HeroSection.tsx">
        <div className="container mx-auto px-4 py-8" data-id="7d88fw1zh" data-path="src/components/HeroSection.tsx">
          <div className="text-center mb-8" data-id="xk1lb7wmv" data-path="src/components/HeroSection.tsx">
            <p className="text-gray-600 font-medium" data-id="no2gzd8t3" data-path="src/components/HeroSection.tsx">Trabajamos con las mejores marcas del mercado</p>
          </div>
          
          <div className="grid grid-cols-3 md:grid-cols-7 gap-8 items-center opacity-60 hover:opacity-100 transition-opacity duration-300" data-id="6b266ltos" data-path="src/components/HeroSection.tsx">
            {trustedBrands.map((brand, index) =>
            <div key={index} className="text-center" data-id="4jzou8amj" data-path="src/components/HeroSection.tsx">
                <div className="h-12 bg-gray-200 rounded-lg flex items-center justify-center mb-2" data-id="yfie80b50" data-path="src/components/HeroSection.tsx">
                  <span className="text-xs font-medium text-gray-600" data-id="zsj4wzchf" data-path="src/components/HeroSection.tsx">{brand.name}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;